import { isEqual, isPlainObject } from "es-toolkit";
import { is } from "immutable";
import React from "react";

import Page from "./renderer/Page";
import PageHeader from "./renderer/PageHeader";

const StageFrameContent = (props) => {
  const { designContext, layout, layoutWidth, theme, pageStyle } = props;
  return (
    <div>
      <PageHeader
        layout={layout}
        layoutWidth={layoutWidth}
        theme={theme}
        pageStyle={pageStyle}
        designContext={designContext}
      />
      <Page {...props} />
    </div>
  );
};

/**
 * Whether two prop values render the same page: Immutable values by value,
 * plain objects (pageStyle, mode) by contents, anything else by identity.
 * Comparing Immutable values stays cheap through edits: `is` checks
 * references first, and an edit shares every unchanged branch, so only the
 * changed path is walked.
 * @param {*} a
 * @param {*} b
 * @returns {boolean}
 */
const isSameProp = (a, b) =>
  is(a, b) || (isPlainObject(a) && isPlainObject(b) && isEqual(a, b));

/**
 * Callers build some props fresh each render, and a stage zoom re-renders the
 * stage without changing any of their values. Re-rendering the whole page on
 * every zoom step is slow on a long design, so the page renders only when a
 * prop's value changes.
 * @param {Record<string, *>} prev
 * @param {Record<string, *>} next
 * @returns {boolean}
 */
const arePropsEqual = (prev, next) =>
  Object.keys({ ...prev, ...next }).every((key) => isSameProp(prev[key], next[key]));

export default React.memo(StageFrameContent, arePropsEqual);
